import {
  ActionType,
  VerifyResetPasswordTokenData,
} from "models/verifyResetPasswordToken";

export const verifyResetPasswordTokenAction = (
  payload: VerifyResetPasswordTokenData
) => {
  return {
    type: ActionType.VERIFY_RESET_TOKEN,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.VERIFY_RESET_TOKEN_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: any) => {
  return {
    type: ActionType.VERIFY_RESET_TOKEN_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.RESET_VERIFY_RESET_TOKEN,
  };
};
